import React from "react";

export default function Monogram() {
  return <span className="monogram-text">OK</span>;
}
